import { render } from "./planningPresta.vue?vue&type=template&id=401add74"
import script from "./planningPresta.vue?vue&type=script&lang=ts"
export * from "./planningPresta.vue?vue&type=script&lang=ts"
script.render = render

export default script